import * as tslib_1 from "tslib";
import { AfterViewInit, ElementRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { LayerService } from '../../../../services/layer.service';
import { HeatmapMode, isFeatureLayer, isGraphicsLayer, isHeatmapRenderer, isMapImageLayer, isSimpleRenderer, isUniqueValueRenderer } from '../../../../types';
import { BaseComponent } from '../../../base.component';
var SymbolEditorContainerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SymbolEditorContainerComponent, _super);
    function SymbolEditorContainerComponent(_vcr, layerService) {
        var _this = _super.call(this, _vcr) || this;
        _this.layerService = layerService;
        _this.pointsAndLines = false;
        _this.heatmapMode = false;
        _this.slotComponents = [];
        _this.heatmapRenderer = undefined;
        _this.isMultiple = false;
        _this.applyColorToEntireLayer = false;
        // tslint:enable:cyclomatic-complexity
        _this.updateLegendSymbol = new EventEmitter();
        return _this;
    }
    Object.defineProperty(SymbolEditorContainerComponent.prototype, "symbols", {
        get: function () {
            return this._symbols;
        },
        set: function (value) {
            this._symbols = value;
            this.getSymbols();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SymbolEditorContainerComponent.prototype, "uniqueLayerId", {
        get: function () {
            return this._uniqueLayerId;
        },
        // tslint:disable:cyclomatic-complexity
        set: function (val) {
            var e_1, _a;
            this._uniqueLayerId = val;
            this.heatmapRenderer = null;
            this.heatmapMode = false;
            this.symbols = null;
            if (val) {
                this.esriLayer = this.layerService.getEsriLayerByUniqueId(this.uniqueLayerId);
                this.layerType = this.esriLayer.type;
                if (isMapImageLayer(this.esriLayer)) {
                    this.symbols = this.esriLayer.sublayers.toArray().filter(function (x) { return x.renderer && x.renderer.symbol; }).map(function (x) { return x.renderer.symbol; });
                }
                else if (isFeatureLayer(this.esriLayer)) {
                    if (isSimpleRenderer(this.esriLayer.renderer)) {
                        this.symbols = [this.esriLayer.renderer.symbol];
                        if (this.esriLayer.mapcoreProps.heatmapMode === HeatmapMode.Auto && !this.layerService.checkIfHeatmapIsOnOrOff(this.esriLayer)) {
                            this.heatmapRenderer = this.esriLayer.mapcoreProps.heatmapRenderer.clone();
                        }
                    }
                    else if (isUniqueValueRenderer(this.esriLayer.renderer) && this.esriLayer.renderer.uniqueValueInfos.some(function (i) { return i.symbol.type === 'picture-marker' || i.symbol.type === 'simple-line'; })) {
                        this.symbols = this.esriLayer.renderer.uniqueValueInfos.map(function (i) { return i.symbol; });
                    }
                    else if (isHeatmapRenderer(this.esriLayer.renderer)) {
                        this.heatmapRenderer = this.esriLayer.renderer.clone();
                        if (isSimpleRenderer(this.esriLayer.mapcoreProps.renderer) && this.esriLayer.mapcoreProps.renderer.symbol) {
                            this.symbols = [this.esriLayer.mapcoreProps.renderer.symbol];
                        }
                    }
                }
                else if (isGraphicsLayer(this.esriLayer)) {
                    this.symbols = this.esriLayer.graphics.toArray().map(function (x) { return x.symbol; });
                }
                if (this.heatmapRenderer && this.esriLayer.mapcoreProps.heatmapMode !== HeatmapMode.Off) {
                    this.isMultiple = false;
                }
            }
            else {
                this.esriLayer = null;
                this.symbols = null;
                this.heatmapRenderer = null;
                try {
                    for (var _b = tslib_1.__values(this.slotComponents), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var slotComponent = _c.value;
                        if (slotComponent.cancel) {
                            slotComponent.cancel();
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                this.slotComponents = [];
                this.closeWindow();
            }
            this.getSymbols();
            if (this.esriLayer) {
                this.heatmapMode = this.heatmapRenderer ? true : false;
                this.pointsAndLines = this.lineSymbol && this.pointSymbol ? true : false;
                if (this.esriLayer.mapcoreProps.applyColorToEntireLayer === undefined && (this.pointSymbol || this.lineSymbol) && this.firstSymbol.color && !(this.heatmapRenderer && isHeatmapRenderer(this.heatmapRenderer))) {
                    this.esriLayer.mapcoreProps.applyColorToEntireLayer = false;
                    this.esriLayer.mapcoreProps.color = this.firstSymbol.color.toCss(true);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SymbolEditorContainerComponent.prototype, "symbolTypes", {
        get: function () {
            return this.symbols.map(function (x) { return x.type; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SymbolEditorContainerComponent.prototype, "pointSymbolEditor", {
        set: function (pointSymbolEditor) {
            if (pointSymbolEditor) {
                this.pointSymbolEditorRef = pointSymbolEditor;
                if (this.pointSymbol) {
                    try {
                        var slotComponent = this.assignLayerSymbolToSlotComponent(this.pointSymbolEditorRef, 'mc-point-symbol-editor', this.pointSymbol);
                        if (this.applyColorToEntireLayer && this.symbolColor) {
                            slotComponent.symbolColor = this.symbolColor;
                        }
                    }
                    catch (_a) { }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SymbolEditorContainerComponent.prototype, "lineSymbolEditor", {
        set: function (lineSymbolEditor) {
            if (lineSymbolEditor) {
                this.lineSymbolEditorRef = lineSymbolEditor;
                if (this.lineSymbol) {
                    try {
                        var slotComponent = this.assignLayerSymbolToSlotComponent(this.lineSymbolEditorRef, 'mc-line-symbol-editor', this.lineSymbol);
                        slotComponent.layerType = this.layerType;
                        if (this.applyColorToEntireLayer && this.symbolColor) {
                            slotComponent.symbolColor = this.symbolColor;
                        }
                    }
                    catch (_a) { }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SymbolEditorContainerComponent.prototype, "polygonSymbolEditor", {
        set: function (polygonSymbolEditor) {
            if (polygonSymbolEditor) {
                this.polygonSymbolEditorRef = polygonSymbolEditor;
                if (this.polygonSymbol) {
                    try {
                        var slotComponent = this.assignLayerSymbolToSlotComponent(this.polygonSymbolEditorRef, 'mc-polygon-symbol-editor', this.polygonSymbol);
                        slotComponent.layerType = this.layerType;
                        if (this.applyColorToEntireLayer && this.symbolColor) {
                            slotComponent.symbolColor = this.symbolColor;
                        }
                    }
                    catch (_a) { }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SymbolEditorContainerComponent.prototype, "textSymbolEditor", {
        set: function (textSymbolEditor) {
            if (textSymbolEditor) {
                this.textSymbolEditorRef = textSymbolEditor;
                this.assignLayerSymbolToSlotComponent(this.textSymbolEditorRef, 'mc-text-symbol-editor', this.textSymbol);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SymbolEditorContainerComponent.prototype, "heatmapEditor", {
        set: function (heatmapEditor) {
            this.heatmapEditorRef = heatmapEditor;
            if (heatmapEditor) {
                this.assignHeatmapSymboltoSlotComponent(this.heatmapEditorRef, 'mc-heatmap-editor', this.heatmapRenderer);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SymbolEditorContainerComponent.prototype, "layerOpacityEditor", {
        set: function (layerOpacityEditor) {
            if (layerOpacityEditor) {
                this.layerOpacityEditorRef = layerOpacityEditor;
                try {
                    var slotComponent = this.assignLayerSymbolToSlotComponent(this.layerOpacityEditorRef, 'mc-layer-opacity-editor');
                    if (this.uniqueLayerId) {
                        slotComponent.uniqueLayerId = this.uniqueLayerId;
                    }
                    else {
                        slotComponent.opacity = this.opacity;
                    }
                }
                catch (_a) { }
            }
        },
        enumerable: true,
        configurable: true
    });
    SymbolEditorContainerComponent.prototype.ngAfterViewInit = function () {
        this.isReady();
        this.setParentWindow();
    };
    SymbolEditorContainerComponent.prototype.setParentWindow = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                // TODO: Remove window references
                this.getClosestAncestor('mc-window').then(function (window) {
                    if (window) {
                        _this.parentWindow = window;
                        _this.parentWindow.addEventListener('openChange', function (open) {
                            if (open.detail) {
                                _this.symbolColor = null;
                                _this.opacity = 100;
                            }
                            else {
                                _this.close();
                            }
                        });
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    SymbolEditorContainerComponent.prototype.getSymbols = function () {
        if (!this.symbols || this.symbols.length === 0) {
            return;
        }
        this.firstSymbol = this.symbols[0];
        this.isMultiple = this.symbols.length > 1;
        this.lineSymbol = this.getSymbolBasedOnType(['simple-line', 'polyline']);
        this.pointSymbol = this.getSymbolBasedOnType(['simple-marker', 'picture-marker']);
        this.polygonSymbol = this.getSymbolBasedOnType(['simple-fill']);
        this.textSymbol = this.getSymbolBasedOnType(['text']);
        this.heatmapSymbol = this.getSymbolBasedOnType(['simple-marker', 'picture-marker']);
    };
    SymbolEditorContainerComponent.prototype.assignHeatmapSymboltoSlotComponent = function (slotRef, tagName, renderer) {
        var slotComponent = this.getSlotAssignedComponent(slotRef, tagName);
        if (renderer) {
            slotComponent.heatmapRenderer = renderer;
        }
        if (this.uniqueLayerId) {
            slotComponent.uniqueLayerId = this.uniqueLayerId;
        }
        if (this.slotComponents.indexOf(slotComponent) < 0) {
            this.slotComponents.push(slotComponent);
        }
        return slotComponent;
    };
    SymbolEditorContainerComponent.prototype.assignLayerSymbolToSlotComponent = function (slotRef, tagName, symbol) {
        var _this = this;
        var slotComponent = this.getSlotAssignedComponent(slotRef, tagName);
        slotComponent.applyColorToEntireLayer = this.applyColorToEntireLayer;
        slotComponent.addEventListener('colorChange', function (e) { return _this.colorChange(e); });
        slotComponent.addEventListener('applyColorToEntireLayerChange', function (e) { return _this.applyColorToEntireLayerCheckboxChange(e); });
        if (symbol) {
            slotComponent.layerSymbol = symbol;
            slotComponent.multipleSymbols = this.isMultiple;
        }
        if (this.uniqueLayerId) {
            slotComponent.uniqueLayerId = this.uniqueLayerId;
        }
        if (this.slotComponents.indexOf(slotComponent) < 0) {
            this.slotComponents.push(slotComponent);
        }
        return slotComponent;
    };
    SymbolEditorContainerComponent.prototype.getSymbolBasedOnType = function (types) {
        if (this.symbols) {
            var foundArray = this.symbols.filter(function (x) { return types.includes(x.type); });
            if (foundArray.length === 1) {
                return foundArray[0];
            }
            if (foundArray.length > 1) {
                // When there are more than one symbols of the same type on the layer, apply Color to Entire Layer.
                var symbol = foundArray[0];
                if (symbol.color) {
                    this.esriLayer.mapcoreProps.applyColorToEntireLayer = true;
                    this.esriLayer.mapcoreProps.color = symbol.color.toCss(true);
                }
                return symbol;
            }
        }
        return null;
    };
    // tslint:disable:cyclomatic-complexity
    SymbolEditorContainerComponent.prototype.apply = function () {
        var _this = this;
        var e_2, _a;
        var _loop_1 = function (item) {
            if (item.applyChange) {
                var isHeatmapMode = this_1.esriLayer && this_1.layerService.checkIfHeatmapIsOnOrOff(this_1.esriLayer);
                if (item.heatmapRenderer) {
                    var renderer = item.applyChange();
                    if (isFeatureLayer(this_1.esriLayer)) {
                        this_1.heatmapRenderer = renderer.clone();
                        if (isHeatmapMode) {
                            this_1.esriLayer.renderer = this_1.heatmapRenderer;
                        }
                        else {
                            this_1.esriLayer.mapcoreProps.heatmapRenderer.blurRadius = this_1.heatmapRenderer.blurRadius;
                            this_1.esriLayer.mapcoreProps.heatmapRenderer.colorStops = this_1.heatmapRenderer.colorStops;
                            this_1.esriLayer.mapcoreProps.heatmapRenderer.maxPixelIntensity = this_1.heatmapRenderer.maxPixelIntensity;
                            this_1.esriLayer.mapcoreProps.heatmapRenderer.minPixelIntensity = this_1.heatmapRenderer.minPixelIntensity;
                        }
                    }
                }
                else {
                    var oldId_1 = item.layerSymbol ? item.layerSymbol.id : null;
                    var newSymbol = item.applyChange();
                    if (this_1.esriLayer && oldId_1 && newSymbol) {
                        if (isMapImageLayer(this_1.esriLayer)) {
                            if (isHeatmapMode) {
                                this_1.esriLayer.mapcoreProps.renderer.symbol = newSymbol;
                            }
                            else {
                                this_1.esriLayer.sublayers.toArray().find(function (x) { return x.renderer && x.renderer.symbol.id === oldId_1; }).renderer.symbol = newSymbol;
                            }
                        }
                        else if (isFeatureLayer(this_1.esriLayer)) {
                            if (isHeatmapMode) {
                                this_1.esriLayer.mapcoreProps.renderer.symbol = newSymbol;
                            }
                            else if (isSimpleRenderer(this_1.esriLayer.renderer)) {
                                this_1.esriLayer.renderer.symbol = newSymbol;
                            }
                            else if (isUniqueValueRenderer(this_1.esriLayer.renderer) && this_1.esriLayer.renderer.uniqueValueInfos.some(function (i) { return i.symbol.type === 'picture-marker'; })) {
                                this_1.esriLayer.renderer.uniqueValueInfos.find(function (x) { return x.symbol.id === oldId_1; }).symbol = newSymbol;
                            }
                        }
                        else if (isGraphicsLayer(this_1.esriLayer)) {
                            this_1.esriLayer.graphics.toArray().find(function (x) { return x.symbol.id === oldId_1; }).symbol = newSymbol;
                            for (var i = 0; i < this_1.symbols.length; i++) {
                                if (this_1.symbols[i].id === oldId_1) {
                                    this_1.symbols.splice(i, 1, newSymbol);
                                }
                            }
                        }
                    }
                }
            }
        };
        var this_1 = this;
        try {
            for (var _b = tslib_1.__values(this.slotComponents), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                _loop_1(item);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        if ((this.lineSymbol || this.pointSymbol || this.polygonSymbol) && (this.esriLayer && this.esriLayer.mapcoreProps.applyColorToEntireLayer)) {
            this.symbols.forEach(function (sym) {
                sym.color.setColor(_this.esriLayer.mapcoreProps.color);
                if (sym.outline) {
                    sym.outline.color.setColor(_this.esriLayer.mapcoreProps.color);
                }
            });
        }
        this.updateLegendSymbol.emit(true);
        if (this.uniqueLayerId) {
            var layer = this.layerService.getEsriLayerByUniqueId(this.uniqueLayerId);
            if (layer) {
                if (isGraphicsLayer(layer)) {
                    var changedGraphics = layer.graphics.clone();
                    layer.removeAll();
                    layer.addMany(changedGraphics.toArray());
                }
                else if (layer.type !== 'group') {
                    layer.refresh();
                }
            }
        }
        var opacityEditor = this.getSlotAssignedComponent(this.layerOpacityEditorRef, 'mc-layer-opacity-editor');
        window.dispatchEvent(new CustomEvent('symbolChange', { detail: this.uniqueLayerId }));
        window.dispatchEvent(new CustomEvent('newSymbols', { detail: {
                layerId: this.uniqueLayerId,
                symbols: this.slotComponents.filter(function (sc) { return sc.nodeName.toLowerCase() !== 'mc-layer-opacity-editor'; }).map(function (sc) { return sc.layerSymbol; }),
                opacity: opacityEditor.opacity
            } }));
        this.close();
    };
    // tslint:enable:cyclomatic-complexity
    SymbolEditorContainerComponent.prototype.colorChange = function (e) {
        var e_3, _a;
        this.symbolColor = e.detail;
        if (this.applyColorToEntireLayer) {
            try {
                for (var _b = tslib_1.__values(this.slotComponents), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var slotComponent = _c.value;
                    slotComponent.symbolColor = e.detail;
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        if (this.esriLayer) {
            this.esriLayer.mapcoreProps.color = e.detail;
        }
    };
    SymbolEditorContainerComponent.prototype.applyColorToEntireLayerCheckboxChange = function (e) {
        this.applyColorToEntireLayer = e.detail;
        if (this.esriLayer) {
            this.esriLayer.mapcoreProps.applyColorToEntireLayer = this.applyColorToEntireLayer;
            if (!e.detail) {
                this.esriLayer.mapcoreProps.color = null;
            }
        }
    };
    SymbolEditorContainerComponent.prototype.cancel = function () {
        this.close();
    };
    SymbolEditorContainerComponent.prototype.close = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.uniqueLayerId = null;
                this.closeWindow();
                return [2 /*return*/];
            });
        });
    };
    SymbolEditorContainerComponent.prototype.closeWindow = function () {
        if (this.parentWindow && this.parentWindow.isOpened) {
            this.parentWindow.close();
        }
    };
    return SymbolEditorContainerComponent;
}(BaseComponent));
export { SymbolEditorContainerComponent };
